import React, { useEffect, useState } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import CustomDatePicker from "../../../../components/Custom-Datepicker";

const AllInvoiceReport = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("All Invoice Report"));
  }, []);
  const [loading, setLoading] = useState(true);
  const [invoiceReport, setInvoiceReport] = useState([]);
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
  });

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };

  const fetchInvoiceReport = async (fromDate = "", toDate = "") => {
    try {
      setLoading(true);
      const fromDateAPI = fromDate
        ? moment(fromDate, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";
      const toDateAPI = toDate
        ? moment(toDate, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      const url = `${API_URL}projectmanagement/reports/7?P_FromDate=${fromDateAPI}&P_ToDate=${toDateAPI}`;
      const response = await GetServiceCaller(url);
      if (response?.status === 200) {
        setInvoiceReport(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetData = async () => {
    const { fromDate, toDate } = formData;

    // Format dates only if they exist
    const formattedFromDate = fromDate
      ? moment(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? moment(toDate).format("YYYY-MM-DD") : "";

    const url = `${API_URL}projectmanagement/reports/7?P_FromDate=${formattedFromDate}&P_ToDate=${formattedToDate}`;

    setLoading(true); // start loading indicator
    try {
      const response = await GetServiceCaller(url);
      if (response?.status === 200) {
        setInvoiceReport(response?.data?.data || []);
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Initial load without dates
  useEffect(() => {
    fetchInvoiceReport();
  }, []);

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
         <div className="container-fluid p-0">
  <div className="row g-2 align-items-end mb-3">
    {/* Date Filters - will stack on small screens */}
    <div className="col-12 col-md-8">
      <div className="row g-2">
        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
          <div className="mb-2">
            <label className="form-label small mb-1">From Date</label>
            <CustomDatePicker
              name="fromDate"
              className="form-control form-control-sm"
              placeholderText="DD-MMM-YYYY"
              handleChange={(e) => handleChange(e)}
              value={formData.fromDate}
            />
          </div>
        </div>
        
        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
          <div className="mb-2">
            <label className="form-label small mb-1">To Date</label>
            <CustomDatePicker
              name="toDate"
              className="form-control form-control-sm"
              placeholderText="DD-MMM-YYYY"
              handleChange={(e) => handleChange(e)}
              value={formData.toDate}
            />
          </div>
        </div>
      </div>
    </div>

    {/* Buttons - will align right and stack properly */}
    <div className="col-12 col-md-4">
      <div className="d-flex flex-wrap justify-content-end gap-2">
        <button
          className="custom-btn btn-sm"
          onClick={() => {
            setFormData({
              fromDate: "",
              toDate: "",
            });
            fetchInvoiceReport();
          }}
        >
          Reset
        </button>
        <button 
          className="custom-btn btn-sm"
          onClick={handleGetData}
        >
          Get Data
        </button>
      </div>
    </div>
  </div>
</div>

          <Table bordered striped hover>
            <thead id="thcolor" className="text-center">
              <tr>
                <th  style={{width:"40px"}}>Project Type</th>
                <th style={{width:"40px"}}>Invoice Amount</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
            <tr>
                             <td colSpan={21} className="text-center py-4">
                               <div className="d-flex justify-content-center">
                                 <FaSpinner class="spinner" />
                               </div>
                               <div className="text-muted mt-2">Loading</div>
                             </td>
                           </tr>
              ) : Object.keys(invoiceReport).length === 0 ? (
                <tr>
                  <td colSpan={21} className="text-center text-muted py-3">
                    No Record Found
                  </td>
                </tr>
              ) : (
                Object.entries(invoiceReport).map(([key, value]) => {
                  let displayKey = key
                    .replace("invoice", "")
                    .replace("Data", "");
                  displayKey =
                    displayKey.charAt(0).toUpperCase() + displayKey.slice(1);
                  const isTotal = displayKey === "Total";
                  const formattedAmount = `Rs. ${value}`;

                  return (
                    <tr key={key}>
                      <td className="text-center">
                        {isTotal ? <strong>{displayKey}</strong> : displayKey}
                      </td>
                      <td className="text-end">
                        {isTotal ? (
                          <strong>{formattedAmount}</strong>
                        ) : (
                          formattedAmount
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default AllInvoiceReport;
